enum EnumRegistrationCardStatus {
    Unreceived = "Unreceived",
    Received = "Received",
    ReceivedByProxy = "ReceivedByProxy"
}

export default EnumRegistrationCardStatus